(function () {
  'use strict';

  var STORAGE_KEY = 'sucursal_store';
  var GIFT_CARD_TITLE = 'tarjetas de regalo';
  var GIFT_CARD_HANDLE = 'tarjetas-de-regalo';

  function getState() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) { return null; }
  }

  // ── EXCEPCIÓN TARJETAS DE REGALO ──────────────────────────────
  function normalizarTexto(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  }

  function esTarjetaRegaloItem(item) {
    if (!item) return false;

    var titulo = normalizarTexto(item.product_title || item.title);
    var handle = normalizarTexto(item.handle).replace(/\s+/g, '-');

    return titulo === GIFT_CARD_TITLE || handle === GIFT_CARD_HANDLE;
  }

  // ── MODAL DE ADVERTENCIA DE CARRITO ──────────────────────────
  function crearModalCarrito() {
    var existing = document.getElementById('sucursal-cart-modal');
    if (existing) return existing;

    var modal = document.createElement('div');
    modal.id = 'sucursal-cart-modal';
    modal.innerHTML = [
      '<div class="scart-overlay">',
        '<div class="scart-box">',
          '<button class="scart-close" id="scart-close">&#10005;</button>',
          '<div class="scart-icon">&#128722;</div>',
          '<h3 class="scart-title">Productos afectados en tu carrito</h3>',
          '<p class="scart-subtitle" id="scart-subtitle"></p>',
          '<div class="scart-items" id="scart-items"></div>',
          '<div class="scart-actions">',
            '<button class="scart-btn scart-btn--secondary" id="scart-btn-eliminar">',
              'Eliminar del carrito',
            '</button>',
            '<button class="scart-btn scart-btn--primary" id="scart-btn-ok">',
              'Mantener y continuar',
            '</button>',
          '</div>',
        '</div>',
      '</div>'
    ].join('');

    document.body.appendChild(modal);

    document.getElementById('scart-close').addEventListener('click', cerrarModal);
    document.getElementById('scart-btn-ok').addEventListener('click', cerrarModal);

    modal.querySelector('.scart-overlay').addEventListener('click', function (e) {
      if (e.target === this) cerrarModal();
    });

    return modal;
  }

  function mostrarModalCarrito(items, sucursal) {
    var modal = crearModalCarrito();
    var subtitle = document.getElementById('scart-subtitle');
    var lista = document.getElementById('scart-items');
    var btnEliminar = document.getElementById('scart-btn-eliminar');

    subtitle.textContent = 'Los siguientes productos no tienen stock suficiente en ' + sucursal + ':';

    lista.innerHTML = items.map(function (item) {
      return [
        '<div class="scart-item">',
          '<span class="scart-item__name">' + item.title + '</span>',
          '<span class="scart-item__stock">',
            item.disponible > 0
              ? 'Solo ' + item.disponible + ' disponible' + (item.disponible !== 1 ? 's' : '')
              : 'Agotado en esta tienda',
          '</span>',
        '</div>'
      ].join('');
    }).join('');

    btnEliminar.onclick = function () {
      eliminarItemsProblematicos(items).then(function () {
        cerrarModal();
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      });
    };

    modal.style.display = 'flex';
    document.body.style.overflow = 'hidden';
  }

  function cerrarModal() {
    var modal = document.getElementById('sucursal-cart-modal');
    if (modal) modal.style.display = 'none';
    document.body.style.overflow = '';
  }

  // ── ELIMINAR ITEMS DEL CARRITO ────────────────────────────────
  function eliminarItemsProblematicos(items) {
    var updates = {};
    items.forEach(function (item) {
      updates[item.variantId] = 0;
    });

    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    })
      .then(function (r) { return r.json(); })
      .catch(function () {});
  }

  // ── VALIDAR CARRITO CONTRA NUEVA SUCURSAL ─────────────────────
  function validarCarrito(state) {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart.items || !cart.items.length) return;

        // Tarjetas de regalo queda totalmente fuera de la validación por sucursal.
        var itemsValidables = cart.items.filter(function (item) {
          return !esTarjetaRegaloItem(item);
        });

        if (!itemsValidables.length) return;

        var productIds = [...new Set(
          itemsValidables.map(function (item) { return String(item.product_id); })
        )];

        return fetch(
          'https://sioconn.dislicores.com/poligonos/inventory?locationId=' +
          encodeURIComponent(state.id) +
          '&productIds=' + productIds.join(',')
        )
          .then(function (r) { return r.json(); })
          .then(function (inventories) {
            var variantMap = {};

            inventories.forEach(function (producto) {
              producto.variants.forEach(function (v) {
                var numId = v.variantId.split('/').pop();
                variantMap[numId] = v.available;
              });
            });

            var problematicos = itemsValidables.filter(function (item) {
              var disponible = variantMap[String(item.variant_id)];
              return disponible !== undefined && disponible < item.quantity;
            }).map(function (item) {
              return {
                title: item.title,
                variantId: item.variant_id,
                cantidad: item.quantity,
                disponible: variantMap[String(item.variant_id)] || 0
              };
            });

            if (problematicos.length > 0) {
              mostrarModalCarrito(problematicos, state.nombre);
            }
          });
      })
      .catch(function () {});
  }

  // ── ESCUCHAR CAMBIO DE SUCURSAL ───────────────────────────────
  document.addEventListener('sucursal:changed', function (e) {
    if (e.detail) validarCarrito(e.detail);
  });

})();
